import { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Paper,
    Stack,
    CircularProgress,
    Alert,
    Divider
} from "@mui/material";
import apiClient from "../../utils/apiClient";

const USER_TYPES = [
    { value: "user", label: "User" },
    { value: "showroom", label: "Showroom" },
    { value: "technician", label: "Technician" }
];

const PushNotifications = () => {
    const [formData, setFormData] = useState({
        userType: "",
        title: "",
        body: "",
        image: null,
        action: "",
        timestamp: ""
    });
    const [imagePreview, setImagePreview] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    // Unified handler for text fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle image file input and preview
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                image: file
            }));
            setImagePreview(URL.createObjectURL(file));
        }
    };

    // Form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        const { userType, title, body, image } = formData;
        if (!userType || !title || !body) {
            setError("All fields except 'Action' and 'Timestamp' are required.");
            return;
        }
        setLoading(true);
        try {
            const data = new FormData();
            data.append("userType", formData.userType);
            data.append("title", formData.title);
            data.append("body", formData.body);
            // data.append("image", formData.image);
            // if (formData.action || formData.timestamp) {
            //     data.append("data", JSON.stringify({
            //         ...(formData.action ? { action: formData.action } : {}),
            //         ...(formData.timestamp ? { timestamp: formData.timestamp } : {})
            //     }));
            // }
            // await axios.post(
            //     apiUrl + "/notifications/pushnotification/sendall",
            //     data,
            //     // { headers: { "Content-Type": "multipart/form-data" } }
            // );
            await apiClient.post("/notifications/pushnotification/sendall", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setSuccess("Notification sent successfully!");
            setFormData({
                userType: "",
                title: "",
                body: "",
                image: null,
            });
            setImagePreview("");
        } catch (err) {
            setError(err?.response?.data?.message || "Failed to send notification.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                Send Push Notification
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Paper elevation={2} sx={{ p: 3, maxWidth: 500, mx: "auto" }}>
                <form onSubmit={handleSubmit} noValidate>
                    <Stack spacing={2}>
                        <TextField
                            select
                            label="User Type"
                            name="userType"
                            value={formData.userType}
                            onChange={handleChange}
                            required
                            fullWidth
                        >
                            {USER_TYPES.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            label="Title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                            fullWidth
                        />
                        <TextField
                            label="Body"
                            name="body"
                            value={formData.body}
                            onChange={handleChange}
                            required
                            multiline
                            rows={3}
                            fullWidth
                        />
                        {/* Image Preview */}
                        {imagePreview && (
                            <Box sx={{ mt: 1, mb: 1, textAlign: "center" }}>
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{ maxWidth: "100%", maxHeight: 150, borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                                />
                            </Box>
                        )}
                        {/* Upload Button */}
                        <Button
                            variant="outlined"
                            component="label"
                            fullWidth
                        >
                            Upload Image
                            <input
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={handleImageChange}
                            />
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            fullWidth
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            {loading ? "Sending..." : "Send Notification"}
                        </Button>
                    </Stack>
                </form>
            </Paper>
        </Box>
    );
};

export default PushNotifications;
